/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/GridTable/StyleConstant';
import { cellRenderer } from '../../../../SharedModules/utilities/utilities';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

export const getTableHeads = (headerNames, asOfDate) => {
  return [
    {
      headerName: ' ',
      children: [
        {
          headerName: headerNames[0],
          field: headerNames[0] === 'Year' ? 'year' : 'rebateProgram',
          editable: false,
          suppressMenu: false,
          sortable: true,
          sortingOrder: ['desc', 'asc'],
          minWidth: Styles.Width_130,
          cellStyle: { borderRightColor: Styles.BorderColor },
          cellRenderer: 'TextBoxRender',
          filter: 'agTextColumnFilter',
          wrapText: true,
          autoHeight: true,

          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          resizable: true,
        },
      ],
      suppressMenu: false,
    },
    {
      headerName: 'Amount Billed',
      children: [
        {
          headerName: 'Original',
          field: 'original',
          minWidth: Styles.Width_170,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',
          isAmount: true,
        },
        {
          headerName: 'Pricing Adjustments since billing',
          field: 'pricingAdjSinceBilling',
          minWidth: Styles.Width_195,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },

          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',
          isAmount: true,
        },
        {
          headerName: 'Utilization Adjustments since billing',
          field: 'utilizationAdjSinceBilling',
          minWidth: Styles.Width_170,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',

          isAmount: true,
        },
        {
          headerName: 'Other Adjustments',
          field: 'otherAdjustments',
          minWidth: Styles.Width_195,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',

          isAmount: true,
        },
        {
          headerName: 'Current Value of Invoices',
          field: 'currentValueOfInvoices',
          minWidth: Styles.Width_195,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',

          isAmount: true,
        },
      ],

      suppressMenu: false,
    },
    {
      headerName: 'Collections',
      children: [
        {
          headerName: 'Collection Prior to Curent SFY',
          field: 'priorCollcollectionsPriorCurrentSFY',
          minWidth: Styles.Width_170,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',

          isAmount: true,
        },
        {
          headerName: 'Total Principal collected',
          field: 'totalPrincipalCollected',
          minWidth: Styles.Width_170,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',

          isAmount: true,
        },
        {
          headerName: 'Total Interest Collected',
          field: 'totalInterestCollected',
          minWidth: Styles.Width_170,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',

          isAmount: true,
        },
        {
          headerName: 'Total Collections',
          field: 'totalCollections',
          minWidth: Styles.Width_170,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',

          isAmount: true,
        },
      ],

      suppressMenu: false,
    },
    {
      headerName: `OutStanding As of ${asOfDate}`,
      children: [
        {
          headerName: 'Outstanding Principal',
          field: 'princOutstandingPrincipal',
          minWidth: Styles.Width_195,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',

          isAmount: true,
        },
        {
          headerName: 'Outstanding Interest',
          field: 'interestOutstandingInterest',
          minWidth: Styles.Width_150,
          cellStyle: {
            borderRightColor: Styles.BorderColor,
            textAlign: 'right',
          },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          // autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          isTextColorRed: true,
          printPrefixValue: '$',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',

          isAmount: true,
        },
      ],
      suppressMenu: false,
    },
    {
      headerName: '',
      children: [
        {
          headerName: 'Collection Rates for Principal',
          field: 'collectionRatesForPrincipal',
          minWidth: Styles.Width_150,
          cellStyle: { borderRightColor: Styles.BorderColor },
          editable: false,
          sortable: true,
          filter: 'agTextColumnFilter',
          wrapText: true,
          autoHeight: true,
          filterParams: {
            defaultOption: 'startsWith',
            suppressAndOrCondition: true,
            buttons: ['reset'],
            refreshValuesOnOpen: true,
          },
          excelAlignment: 'right',
          isTextColorRed: true,
          printPostfixValue: ' %',
          cellRenderer,
          comparator: amountComparator,
          alignment: 'right',
          isAmount: true,
        },
      ],

      suppressMenu: false,
    },
  ];
};
export const demo = [];
